import $ from 'jquery';
import _ from 'underscore';
import { $window, jqOffOn } from 'util/global';


/** @module */
const sticky = {};


/**
 * @param {jquery} $sticky
 * @param {object} options (optional)
 *
 * NOTE:
 * options = {
 *      top: int,
 *      bottom: int,
 *      stuckClass: string
 *      stuckBottomClass: string
 *      handler: function
 * }
 */
sticky.checkScrollPosition = function($sticky, options) {
    const windowTop = $window.scrollTop();

    var top = options && options.top ? options.top : 10;
    var bottom = options && options.bottom ? options.bottom : null;
    var stuckClass = options && options.stuckClass ? options.stuckClass : 'stuck';
    var stuckBottomClass = options && options.stuckBottomClass
        ? options.stuckBottomClass
        : 'stuck-bottom';
    var handler = options && options.handler ? options.handler : null;

    var isPastTop = windowTop > top;
    var isPastBottom = bottom && windowTop > bottom ? true : false;
    var isStuck = $sticky.hasClass( stuckClass );

    if( isPastTop && !isPastBottom && !isStuck ) {
        $sticky.addClass( stuckClass );
        $sticky.removeClass( stuckBottomClass );
    } else if( !isPastTop && isStuck ) {
        $sticky.removeClass( stuckClass );
    } else if( isPastBottom ) {
        $sticky.removeClass( stuckClass );
        $sticky.addClass( stuckBottomClass );
    } else if ( !isPastBottom ) {
        $sticky.removeClass( stuckBottomClass );
    }

    if( handler ) {
        handler($sticky, options);
    }
};


/**
 * @param {jquery} $sticky
 * @param {object} options (optional)
 *
 * NOTE:
 * options = {
 *      $target: specify another element to trigger stickiness for $sticky
 *      bottom: int,
 *      forceBottom: override bottom auto-calculations
 *      handler: function,
 *      namespace: string (allows for multiple sticky elements on page)
 * }
 */
sticky.stick = function($sticky, options) {
    $sticky.addClass('sticky');

    options = options || {};
    options = _.extend( options, $sticky.data() );

    var $stickyTarget = options.$target && options.$target.length ? options.$target : $sticky;

    var stickyTop = $stickyTarget.offset().top;
    var stickyHeight = $sticky.outerHeight(true);
    var headerOffset = $('#header').outerHeight(true);

    var stickyBottom = options.bottom ? options.bottom : null;
    var forceBottom = options.forceBottom ? options.forceBottom : null;
    var stickyHandler = options.handler ? options.handler : null;
    var stickyName;
    if( options.namespace ) {
        stickyName = options.namespace;
    } else if( $sticky.attr('id') ) {
        stickyName = 'sticky-' + $sticky.attr('id');
    } else if( window.btoa ) {
        stickyName = 'sticky-' + window.btoa( $sticky.text() );
    }

    var bottom;
    if (forceBottom) {
        bottom = forceBottom;
    } else {
        bottom = stickyBottom ? stickyBottom - stickyHeight - headerOffset : null;
    }

    var checkScrollPosition = function () {
        sticky.checkScrollPosition( $sticky, {
            top: stickyTop - headerOffset,
            bottom: bottom,
            handler: stickyHandler
        });
    };

    jqOffOn($window, `scroll.${stickyName} resize.${stickyName}`, _.throttle(checkScrollPosition, 16));
    checkScrollPosition();
};


module.exports = sticky;
